export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_INVOICING_RECORDS",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_INVOICING_RECORDS",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_INVOICING_RECORDS",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_INVOICING_RECORDS",
  DESTROY_FORM: "DESTROY_FORM_INVOICING_RECORDS",
  SET_FORM_ERROR: "SET_FORM_ERROR_INVOICING_RECORDS",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_INVOICING_RECORDS",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_INVOICING_RECORDS",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_INVOICING_RECORDS",
  RESET_STATE: "RESET_STATE_INVOICING_RECORDS",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_INVOICING_RECORDS",
  REMOVE_OBJECT: "REMOVE_OBJECT_INDUSTRIAL_INVOICING_RECORDS",
  CLEAR_FETCHED: "CLEAR_FETCHED_INVOICING_RECORDS",

  LIST_URL: "/accounting/basic/billectacontractinvoicerecord/list/",

  STORE_NAME: "invoicingRecords",
};
